import { configureStore, Tuple } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistCombineReducers,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import rootSaga from '~/sagas';

import { RootState } from '~/types';

import dynamicMiddlewares from './dynamic-middlewares';
import middlewares, { sagaMiddleware } from './middlewares';
import app, { appState } from './slices/app';
import flightSearch, { flightsSearchState } from './slices/flight-search';
import locations, { locationsState } from './slices/location';
import user, { userState } from './slices/user';
import flightBooking, { flightBookingState } from './slices/flight-booking';
import tour, { toursSearchState } from './slices/tour-search'
import itineraryWizard, { itineraryWizardState } from './slices/itinerary-wizard';
import itineraryPackages, { itineraryPackagesState } from './slices/itinerary-packages';

const getDefaultMiddlewareOptions = {
  serializableCheck: {
    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
  },
  // thunk: false,
};

export const initialState = {
  app: appState,
  locations: locationsState,
  user: userState,
  flightSearch: flightsSearchState,
  flightBooking: flightBookingState,
  itineraryWizard: itineraryWizardState,
  itineraryPackages: itineraryPackagesState,
  tour: toursSearchState,
};

export const reducers = {
  app,
  locations,
  user,
  flightSearch,
  flightBooking,
  itineraryWizard,
  itineraryPackages,
  tour,
};

const rootReducer = persistCombineReducers<RootState>(
  {
    key: 'rrsb',
    stateReconciler: autoMergeLevel2,
    storage,
    blacklist: ['alerts'],
    timeout: 0,
  },
  reducers,
);

export const configStore = (preloadedState: any = {}) => {
  const enhancedStore = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware => {
      return new Tuple(
        ...getDefaultMiddleware(getDefaultMiddlewareOptions),
        ...middlewares,
        dynamicMiddlewares,
      );
    },
  });

  sagaMiddleware.run(rootSaga);

  return enhancedStore;
};

export const store = configStore();
export const persistor = persistStore(store);
